import { render, staticRenderFns } from "./AdminPersonSearchDialog.vue?vue&type=template&id=aebdfac0"
import script from "./AdminPersonSearchDialog.vue?vue&type=script&lang=ts"
export * from "./AdminPersonSearchDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports